import { TaskApplication } from '../../pages/superuser/types'

export const vouchersConfig: { [key in TaskApplication]?: boolean } = {
  ADMICOM: true,
  BRIOX: true,
  ECONIA: false,
  EXCHANGE_RATES: false,
  FENNOA: true,
  FIVALDI: true,
  FORTNOX: true,
  HEEROS: true,
  LEMONSOFT: true,
  MAESTRO: true,
  NETVISOR: true,
  NETSUITE: true,
  PROCOUNTOR: true,
  RESTOLUTION: false,
  SIE: true,
  SONET: false,
  TALENOM: true,
  L7: true,
  VISMANET: true,
  XERO: true,
  OSCAR: true,
  FINADECK: true,
  QUICKBOOKS: true,
  TRIPLETEX: true,
  BUSINESS_CENTRAL: true
}

export const voucherAccountingSoftware = [
  TaskApplication.ADMICOM,
  TaskApplication.BRIOX,
  TaskApplication.FENNOA,
  TaskApplication.FIVALDI,
  TaskApplication.FORTNOX,
  TaskApplication.HEEROS,
  TaskApplication.LEMONSOFT,
  TaskApplication.MAESTRO,
  TaskApplication.NETVISOR,
  TaskApplication.NETSUITE,
  TaskApplication.PROCOUNTOR,
  TaskApplication.SIE,
  TaskApplication.TALENOM,
  TaskApplication.L7,
  TaskApplication.VISMANET,
  TaskApplication.XERO,
  TaskApplication.OSCAR,
  TaskApplication.QUICKBOOKS,
  TaskApplication.TRIPLETEX,
  TaskApplication.BUSINESS_CENTRAL
]
